import React from 'react'
import { useCMSEntries } from 'mage-cms'
import useFilterArticlesByExperiment from '../hooks/useFilterArticlesByExperiment'
import { useHelpContext } from '../hooks'
import ContactSection from './ContactSection'
import ResultsView from './ResultsView'
import LoadingView from './LoadingView'
import { useEducationFeature } from 'education-tools'
import SearchSupportButton from './SearchSupportButton'
import NoResultsMessage from './NoResultsMessage'
import { SpacerVertical } from 'mage-deps/@klarna/bubble-ui'

export default function SearchResults() {
  const { searchQuery: query } = useHelpContext()

  const topics = useCMSEntries({ contentType: 'UHQMTopic', filters: { query } })
  const articles = useCMSEntries({
    contentType: 'UHQMArticle',
    filters: { query, 'hidden[ne]': true }
  })
  const filteredArticles = useFilterArticlesByExperiment(articles)
  const isSupportCenterActive = useEducationFeature('meg.merchant-support-center')

  if (topics && filteredArticles) {
    const hasResults = !!topics.length || !!filteredArticles.length

    if (isSupportCenterActive) {
      return (
        <>
          {hasResults && (
            <>
              <ResultsView topics={topics} articles={filteredArticles} />
              <SpacerVertical medium />
            </>
          )}
          <SearchSupportButton />
          {!hasResults && <NoResultsMessage />}
        </>
      )
    } else {
      return (
        <>
          <ContactSection query={query} hasResults={hasResults} />
          <ResultsView topics={topics} articles={filteredArticles} />
        </>
      )
    }
  } else {
    return <LoadingView />
  }
}
